import { useState, useEffect, RefObject } from 'react';

const useIntersectionObserver = ({
  element,
  rootMargin,
}: {
  element: RefObject<Element>;
  rootMargin: string;
}) => {
  const [isVisible, setState] = useState(false);

  useEffect(() => {
    const node = element?.current; // DOM Ref

    if (!node) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setState(entry.isIntersecting);
          observer.unobserve(node);
        }
      },
      { rootMargin }
    );

    observer.observe(node);

    return () => {
      observer.unobserve(node);
    };
  }, [element, rootMargin]);

  return isVisible;
};

export { useIntersectionObserver };
